import React from 'react';
import { find } from 'lodash';
import Dotdotdot from 'react-dotdotdot';

import withAuth from '../../hocs/withAuth';
import PopOverMenu from '../../PopOverMenu';
import BackgroundImage from '../../BackgroundImage';
import StatsigLink from '../../Links/StatsigLink';
import { useStatsig } from '../../hooks/useStatsig';
import config from '../../../../config';

const _ = { find };

const ClubCard = (props) => {
    const { force = {}, forceCardView, auth, onClick, rank, 'data-testid': dataTestId } = props;
    const { id, name, sanctioned, memberCount, location, eventCount, clubMemberRole, isCollege, isHighSchool, clubProfileImages } = props.club;
    const locationValue = location && location.display ? location.display : '';
    const { featureGates } = useStatsig();
    // eslint-disable-next-line no-nested-ternary
    const redirectUrl = `/${isCollege ? 'colleges' : (isHighSchool ? 'schools' : 'clubs')}/${id}`;
    const nextRedirectUrl = `/${isCollege ? 'college' : (isHighSchool ? 'high-school' : 'club')}/${id}`;
    const descriptionItems = [locationValue];
    if (memberCount !== 'undefined') {
        descriptionItems.push(`${memberCount} member${memberCount === 1 ? '' : 's'}`);
    }
    const description = descriptionItems.join(' \u00B7 ');

    const memberFromSimplified = _.find(auth?.user?.clubMemberships, { clubId: id });
    const memberRoleId = (clubMemberRole && clubMemberRole.id) || (memberFromSimplified && memberFromSimplified.roleId);
    const getMemberTagValue = () => {
        switch (memberRoleId) {
            case 6:
                return 'Follower';
            case 3:
                return 'Member';
            case 2:
                return 'Provider';
            case 1:
                return 'Head Provider';
            default:
                return null;
        }
    };
    const isOrganizer = (memberFromSimplified && memberFromSimplified.roleId && (memberFromSimplified.roleId === 1 || memberFromSimplified.roleId === 2));

    const menuOptions = isOrganizer ? [{ label: 'Create Event', value: 'Create Event', id: 'create_event' }] : null;
    const menuOnSelected = (item) => {
        switch (item.id) {
            case 'create_event':
                window.location.href = `/events/create?clubId=${id}`;
                break;
            default:
                break;
        }
    };

    const getDefaultAvatar = () => {
        if (isCollege) {
            return '/img/v2/icons/icon-avatar-college.svg';
        }
        if (isHighSchool) {
            return '/img/v2/icons/icon-avatar-school.svg';
        }
        return '/img/v2/icons/icon-avatar-club.svg';
    };

    return (
        <StatsigLink
            gate={featureGates.CLUB_LINKS_REDIRECT}
            enabledTo={`${config.nextAppHost}${nextRedirectUrl}`}
            disabledTo={redirectUrl}
            onClick={onClick}
            data-testid={dataTestId}
        >
            <div className={`utr-card club-card ${force && force.featured ? 'club-card-featured' : ''}`}>
                <div className={`list-view ${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}>
                    <div className="d-flex">
                        <div className="flex-grow">
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="name show-ellipsis" data-testid={dataTestId && `${dataTestId}.list.name`}>{name}</div>
                                </div>
                                <div className="col-md-3">
                                    <div className="location show-ellipsis" data-testid={dataTestId && `${dataTestId}.list.location`}>{locationValue || ''}</div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row w-100">
                                        <div className={`col-md-4`}>
                                            <div className="values" data-testid={dataTestId && `${dataTestId}.list.event-count`}>
                                                {eventCount}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="values" data-testid={dataTestId && `${dataTestId}.list.member-count`}>
                                                {memberCount}
                                            </div>
                                        </div>
                                        {isOrganizer && (
                                            <div className="col-md-4">
                                                <div
                                                    className="text-teal cursor-pointer ml-auto"
                                                    onClick={(ev) => {
                                                        window.location.href = `/events/create?clubId=${id}`;
                                                        ev.stopPropagation();
                                                        ev.preventDefault();
                                                    }}
                                                    data-testid={dataTestId && `${dataTestId}.list.create-event-link`}
                                                >
                                                    Create Event
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`card-view ${forceCardView || (force && force.cardView) ? 'd-block' : 'd-block d-md-none'}`}>
                    <div className="club-details">
                        <div className="d-flex align-self-stretch">
                            <div className="flex-grow">
                                <div className="row aifs">
                                    <div className="col-8">
                                        <div className="tag-container">
                                            {!!(force && force.featured) && <div className={`tag tag-featured tag-sm mr8`} data-testid={dataTestId && `${dataTestId}.card.featured-tag`}>Featured</div>}
                                            {getMemberTagValue() && (
                                                <div className="btn-sm tag" data-testid={dataTestId && `${dataTestId}.card.member-tag`}>
                                                    {getMemberTagValue()}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className={`avatar-wrapper`}>
                                            <BackgroundImage
                                                baseUrl={'/v1/club/'}
                                                defaultImage={getDefaultAvatar()}
                                                images={clubProfileImages}
                                                imageType={'profile'}
                                                parentStylesClass={'avatar'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {menuOptions && menuOptions.length > 0 && (
                                <PopOverMenu
                                    horizontalEllipsis={false}
                                    popOverMenuClass="mt4 popover-ellipsis"
                                    menuItems={menuOptions}
                                    onSelected={menuOnSelected}
                                />
                            )}
                        </div>
                        <div className="empty-div" />
                        <div className={`name ${sanctioned ? 'sanctioned' : ''}`} data-testid={dataTestId && `${dataTestId}.card.name`}>
                            {!!rank && <span className="rank">{rank}.&nbsp;</span>}{<Dotdotdot clamp={2}>{name}</Dotdotdot>}
                        </div>
                        <div className="details show-ellipsis" data-testid={dataTestId && `${dataTestId}.card.description`}>{description}</div>
                    </div>
                </div>
            </div>
        </StatsigLink>
    );
};

export default withAuth(ClubCard);
